<template>
  <header
    class="flex flex-col gap-5"
    :class="centered ? 'items-center text-center' : 'sm:flex-row sm:items-end sm:justify-between'"
  >
    <div :class="centered ? 'max-w-2xl' : 'max-w-3xl'">
      <div
        v-if="eyebrow || icon"
        class="mb-3 flex items-center gap-2 text-sm font-semibold text-amber-600 dark:text-amber-400"
        :class="centered ? 'justify-center' : ''"
      >
        <span
          v-if="icon"
          class="flex size-8 items-center justify-center rounded-lg bg-amber-500/10 ring-1 ring-amber-500/20"
        >
          <UIcon :name="icon" class="size-4"/>
        </span>
        {{ eyebrow }}
      </div>

      <h1 class="font-serif text-3xl font-semibold tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl">
        {{ title }}
      </h1>
      <p v-if="description" class="mt-3 text-base leading-7 text-gray-600 dark:text-gray-400">
        {{ description }}
      </p>
    </div>

    <div v-if="$slots.actions" class="flex shrink-0 flex-wrap items-center gap-2">
      <slot name="actions"/>
    </div>
  </header>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  title: string
  description?: string
  eyebrow?: string
  icon?: string
  centered?: boolean
}>(), {
  description: '',
  eyebrow: '',
  icon: '',
  centered: false,
})
</script>
